var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.792 29.25C15.6254 29.25 15.4587 29.2223 15.292 29.167C15.1254 29.111 14.9724 29.0137 14.833 28.875L7.41703 21.458C7.13903 21.1807 7.00703 20.8407 7.02103 20.438C7.03503 20.0347 7.16703 19.6943 7.41703 19.417C7.69436 19.167 8.02069 19.042 8.39603 19.042C8.77069 19.042 9.09703 19.167 9.37503 19.417L15.792 25.875L30.583 11.083C30.861 10.8057 31.1944 10.667 31.583 10.667C31.9724 10.667 32.3057 10.8057 32.583 11.083C32.861 11.333 33 11.6597 33 12.063C33 12.4657 32.861 12.792 32.583 13.042L16.792 28.875C16.6254 29.0137 16.4654 29.111 16.312 29.167C16.1594 29.2223 15.986 29.25 15.792 29.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkRound);
export default __webpack_public_path__ + "static/media/checkmark-round.ced17a6f31ea11fb8eff064266426458.svg";
export { ForwardRef as ReactComponent };